var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpinner3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 2C12.75 1.58579 12.4142 1.25 12 1.25C11.5858 1.25 11.25 1.58579 11.25 2V6C11.25 6.41421 11.5858 6.75 12 6.75C12.4142 6.75 12.75 6.41421 12.75 6V2Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6014 5.45904C19.8943 5.16615 19.8943 4.69127 19.6014 4.39838C19.3085 4.10549 18.8336 4.10549 18.5407 4.39838L15.7123 7.22681C15.4194 7.5197 15.4194 7.99458 15.7123 8.28747C16.0052 8.58036 16.4801 8.58036 16.773 8.28747L19.6014 5.45904Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.45926 4.39862C5.16637 4.10573 4.69149 4.10573 4.3986 4.39862C4.10571 4.69151 4.10571 5.16639 4.3986 5.45928L7.22703 8.28771C7.51992 8.5806 7.9948 8.5806 8.28769 8.28771C8.58058 7.99482 8.58058 7.51994 8.28769 7.22705L5.45926 4.39862Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00018 11.2493C1.58597 11.2493 1.25018 11.5851 1.25018 11.9993C1.25018 12.4135 1.58597 12.7493 2.00018 12.7493H6.00018C6.4144 12.7493 6.75018 12.4135 6.75018 11.9993C6.75018 11.5851 6.4144 11.2493 6.00018 11.2493H2.00018Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11.2495C17.5858 11.2495 17.25 11.5853 17.25 11.9995C17.25 12.4137 17.5858 12.7495 18 12.7495H22C22.4142 12.7495 22.75 12.4137 22.75 11.9995C22.75 11.5853 22.4142 11.2495 22 11.2495H18Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.28769 16.7725C8.58058 16.4796 8.58058 16.0048 8.28769 15.7119C7.99479 15.419 7.51992 15.419 7.22702 15.7119L4.3986 18.5403C4.1057 18.8332 4.1057 19.3081 4.3986 19.6009C4.69149 19.8938 5.16636 19.8938 5.45926 19.6009L8.28769 16.7725Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.773 15.7123C16.4801 15.4194 16.0052 15.4194 15.7123 15.7123C15.4194 16.0052 15.4194 16.4801 15.7123 16.773L18.5407 19.6014C18.8336 19.8943 19.3085 19.8943 19.6014 19.6014C19.8943 19.3085 19.8943 18.8336 19.6014 18.5407L16.773 15.7123Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 18C12.75 17.5858 12.4142 17.25 12 17.25C11.5858 17.25 11.25 17.5858 11.25 18V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V18Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpinner3);
export default __webpack_public_path__ + "static/media/spinner-3.e3599a26d1965845d702dd6aa1aed92f.svg";
export { ForwardRef as ReactComponent };